
// Deep lookup to see if any array values have changed
const deepLookup = (array1, array2) => {
    if (array1.length != array2.length) {
      return true;
    }
    for (let i = 0; i < array1.length; i++) {
      if (array1[i] != array2[i]) {
        return true;
      }
    }
    return false;
};
  
export default deepLookup